import React from 'react';
import moment from 'moment';
import { t } from 'i18next';
import { ENGINE_VERSION_1_0 } from '@/store/Engine/constants';
import VersionAlert from '../../VersionHistory/VersionAlert';

interface PublishedContainerProps {
  engineVersion: string;
  publishedDate?: string;
}

const CentrifugalPublishedContainer: React.FC<PublishedContainerProps> = ({ engineVersion, publishedDate }) => {
  return (
    <div
      className="published-container"
      style={{ display: 'flex', justifyContent: engineVersion === ENGINE_VERSION_1_0 ? 'space-between' : 'flex-end' }}
    >
      <VersionAlert engineVersion={engineVersion} />
      {publishedDate && (
        <span>
          {t('publishedOn')} {moment(publishedDate).format('MMM D, YYYY')}
        </span>
      )}
    </div>
  );
};

export default CentrifugalPublishedContainer;
